<div class="modal-body" id="modal-basic-title" tabindex="-1" role="dialog">
  <h5 class="modal-title">{{ announcement | translateField: 'title' }}</h5>
  <div class="card-subtitle text-muted">{{ announcement.publish_at | date: 'short' }}</div>
  <p class="mt-3" style="white-space: pre-wrap;">
    {{ announcement | translateField: 'body' }}
  </p>
</div>
<div class="modal-footer d-flex justify-content-between">
  <div>
    <button *ngIf="announcement.order_link" (click)="router.navigate(['/new-shift'], { queryParams: { new: true } })" type="button" class="btn btn-primary me-2" i18n>New order</button>
    <a *ngIf="announcement.custom_link_text && announcement.custom_link_href" [href]="announcement.custom_link_href" target="_system" type="button" class="btn btn-primary">{{ announcement | translateField: 'custom_link_text' }}</a>
  </div>
  <button (click)="activeModal.dismiss()" type="button" class="btn btn-secondary" i18n>Dismiss</button>
</div>